import { SxStyleProp } from 'theme-ui'

export const productListTheme: SxStyleProp = {
  productList: {},
}
